export default __webpack_public_path__ + "static/mission-statement-b95b1c8e5fa9325b9cfb4d5c462d9765.webp";